
interface ListingsResultsSummaryProps {
  currentPage: number;
  itemsPerPage: number;
  totalItems: number;
  isLoading?: boolean;
}

export function ListingsResultsSummary({
  currentPage,
  itemsPerPage,
  totalItems,
  isLoading = false,
}: ListingsResultsSummaryProps) {
  if (isLoading) {
    return (
      <div className="flex justify-between items-center mb-6">
        <div className="text-muted-foreground" id="listings-loading-summary" aria-live="polite">
          Loading properties...
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-between items-center mb-6">
      <div className="text-muted-foreground" id="listings-results-summary" aria-live="polite">
        Showing{" "}
        {totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1}
        {totalItems > 0 ? `-${Math.min(currentPage * itemsPerPage, totalItems)}` : ""}
        {" "}of {totalItems} properties
      </div>
    </div>
  );
}
